module.exports = __webpack_public_path__ + "img/Z60Q_16.869dfcae.jpg";